import Model from '../Model'

export default class ParcelMachine extends Model {
  resource () {
    return 'parcel-machines'
  }

  primaryKey () {
    return 'id'
  }
}
